import { User } from '../App';
import { SuperAdminView } from './SuperAdminDashboard';
import { Button } from './ui/button';
import { 
  LayoutDashboard, 
  Users, 
  Database, 
  Code2,
  Package,
  CreditCard, 
  Activity, 
  Settings, 
  LogOut,
  Building2
} from 'lucide-react';

interface SuperAdminSidebarProps {
  user: User;
  currentView: SuperAdminView;
  onViewChange: (view: SuperAdminView) => void;
  onLogout: () => void;
}

export default function SuperAdminSidebar({ 
  user, 
  currentView, 
  onViewChange, 
  onLogout 
}: SuperAdminSidebarProps) {
  const menuItems = [
    { id: 'overview' as SuperAdminView, label: 'Overview', icon: LayoutDashboard },
    { id: 'clients' as SuperAdminView, label: 'Clients', icon: Users },
    { id: 'erp-masters' as SuperAdminView, label: 'ERP Masters', icon: Database },
    { id: 'api-templates' as SuperAdminView, label: 'API Templates', icon: Code2 },
    { id: 'plans' as SuperAdminView, label: 'Plans', icon: Package },
    { id: 'subscription' as SuperAdminView, label: 'Subscription & Billing', icon: CreditCard },
    { id: 'logs' as SuperAdminView, label: 'Logs & Monitoring', icon: Activity },
    { id: 'settings' as SuperAdminView, label: 'Settings', icon: Settings },
  ];

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
      {/* Logo and Branding */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#0052CC] to-indigo-600 rounded-lg blur-sm opacity-50"></div>
            <div className="relative w-10 h-10 bg-gradient-to-br from-[#0052CC] to-indigo-600 rounded-lg flex items-center justify-center">
              <Building2 className="w-6 h-6 text-white" />
            </div>
          </div>
          <div>
            <h1 className="text-lg bg-gradient-to-r from-[#0052CC] to-indigo-600 bg-clip-text text-transparent">AIS Connect</h1>
            <p className="text-xs text-gray-500">Super Admin</p>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentView === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-[#0052CC] text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-sm">{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* User Profile and Logout */}
      <div className="p-4 border-t border-gray-200 space-y-3">
        <div className="px-4 py-2">
          <p className="text-sm text-gray-900">{user.name}</p>
          <p className="text-xs text-gray-500">{user.email}</p>
        </div>
        <Button
          onClick={onLogout}
          variant="outline"
          className="w-full flex items-center justify-center space-x-2"
        >
          <LogOut className="w-4 h-4" />
          <span>Logout</span>
        </Button>
      </div>
    </aside>
  );
}
